import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { useRef as f } from "react";
import { u as r } from "./index-6a632112.mjs";
import { c as t, r as c, s as o, Q as l, k as u, e as x } from "./themes-5f0b3c3d.mjs";
import { f as p } from "./fontWeights-a25f8f91.mjs";
import { t as s } from "./textStyles-42cab346.mjs";
import { S as m } from "./cancelClose-87fdf326.mjs";
import { S as $ } from "./informationFilled-05d57719.mjs";
import { S as T } from "./warningFilled-691cfde1.mjs";
import { Disclosures as y } from "./disclosure.js";
import "./lineHeights-72d3110c.mjs";
import "./types-b577bf77.mjs";
const w = "TOP_BANNER_BODY_DATA_TEST_ID", k = "1px", B = "0.5px", C = r.div`
  text-align: justify;
  overflow: hidden;
  word-break: break-word;
  display: flex;

  && * {
    color: ${t.brandTwilight[0]} !important;
    :hover {
      color: ${t.brandTwilight[0]} !important;
    }
  }

  &.open {
    display: block;
    height: auto;
    *,
    *::before,
    *::after {
      font-size: ${s.body.medium.s.fontSize};
      &:is(h1, h2, h3, h4, h5, h6, p, a, span) {
        margin: 0;
      }
      margin-block-start: 0;
      margin-block-end: 0;
    }
  }

  p {
    white-space: pre-wrap;
    a {
      color: ${t.brandTwilight[0]};
      &:focus {
        outline-offset: ${B};
        outline-color: ${t.brandTwilight[0]};
        outline-style: solid;
        outline-width: ${k};
        border-radius: ${c["1x"]};
        text-decoration: none;
      }
    }
  }
  strong {
    font-weight: ${p.body.semibold};
  }
  b {
    font-weight: ${p.body.semibold};
  }
`, S = r.div`
  display: flex;
`, _ = ({ children: i }) => /* @__PURE__ */ e(S, { children: /* @__PURE__ */ e(C, { "data-testid": w, className: "open", children: typeof i == "string" ? /* @__PURE__ */ e("div", { children: i }) : i }) }), v = "1px", I = r.button`
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  padding: 0;
  color: ${t.brandTwilight[0]};

  height: ${o["6x"]};
  &:focus {
    outline-offset: ${o.px};
    outline-color: ${t.brandTwilight[0]};
    outline-style: solid;
    outline-width: ${v};
    border-radius: ${c["1x"]};
  }

  &:focus:not(:focus-visible) {
    outline: none;
    border: none;
    box-shadow: none;
  }

  &:hover {
    cursor: pointer;
  }
`, D = ({
  ariaLabel: i = "Close",
  onClickClose: n
}) => /* @__PURE__ */ e(
  I,
  {
    onClick: n,
    tabIndex: 0,
    "aria-label": i,
    role: "button",
    children: /* @__PURE__ */ e(m, { width: o["6x"], height: o["6x"], "aria-hidden": !0 })
  }
), E = r.div`
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  width: 100%;
`, N = r.div`
  overflow: hidden;
  position: relative;
  width: 100%;
`, W = r.div`
  box-sizing: border-box;
  width: 100%;

  display: flex;
  gap: ${o["2x"]};

  padding-left: unset;
  padding-right: unset;
  min-height: ${o["8x"]};
  background-size: 100% 200%;
  background-position: 0%
    calc(0% - #{$fds-banner-notification__bottom-border--height});

  @media ${l.tabletAndUp} {
    padding-left: 62px;
    padding-right: 62px;
  }
  @media ${l.laptopAndUp} {
    padding-left: ${o["25x"]};
    padding-right: ${o["25x"]};
  }
  @media ${l.desktopAndUp} {
    padding-left: 240px;
    padding-right: 240px;
  }
`, A = r.div`
  width: 100%;
  display: flex;
  min-height: ${o["5x"]};
  gap: ${o["6x"]};
  padding: ${o["1x"]} 0px;
  flex-grow: 1;
`, z = r.div`
  display: flex;
  width: ${o["5x"]};
  height: ${o["5x"]};
  flex-shrink: 0;
  color: ${t.brandTwilight[0]};
`, O = r.span`
  font-family: ${u};
  line-height: ${s.body.medium.s.lineHeight};

  color: ${t.brandTwilight[0]};
  font-size: ${s.body.medium.s.fontSize};
  font-weight: ${x.medium.S.fontWeight};
  word-break: break-word;
`, U = (i) => {
  const n = {};
  switch (i) {
    case "primary":
      n.backgroundColor = `${t.accentBlue[1e3]}`;
      break;
    case "neutral":
      n.backgroundColor = `${t.brandTwilight[1e3]}`;
      break;
    case "warning":
      n.backgroundColor = `${t.utilityCaution[1e3]}`;
      break;
    case "error":
      n.backgroundColor = `${t.utilityDanger[1e3]}`;
      break;
  }
  return n;
}, F = r.div`
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: ${o["1x"]};
  height: ${o["8x"]};
  width: ${o["8x"]};
`, M = ({
  variant: i = "neutral",
  body: n,
  disclosures: a,
  onClickClose: h,
  ...g
}) => {
  const b = f(null);
  return /* @__PURE__ */ e(
    E,
    {
      ref: b,
      ...g,
      style: U(i),
      role: "alert",
      children: /* @__PURE__ */ e(N, { children: /* @__PURE__ */ d(W, { children: [
        /* @__PURE__ */ d(A, { children: [
          /* @__PURE__ */ e(z, { "aria-hidden": !0, children: i === "warning" || i === "error" ? /* @__PURE__ */ e(T, { "aria-label": i, size: "xs" }) : /* @__PURE__ */ e($, { "aria-label": "Information", size: "xs" }) }),
          /* @__PURE__ */ d(O, { children: [
            /* @__PURE__ */ e(_, { children: n }),
            a && /* @__PURE__ */ e(
              y,
              {
                disclosureContent: a?.disclosureContent,
                id: a?.id,
                className: a?.className,
                disclosureTitleColor: a?.disclosureTitleColor,
                style: a?.style
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e(F, { children: /* @__PURE__ */ e(D, { onClickClose: h }) })
      ] }) })
    }
  );
};
export {
  M as TopBanner
};
